<template>
  <div class="project-card pt-20 pb-12 px-9 w-full sm:w-300p lg:w-488p h-full rounded-45p border cursor-pointer flex flex-col justify-between">
    <div class="flex justify-center">
      <slot name="logo"/>
    </div>

    <div>
      <h3 class="text-navy font-bold text-24 text-left">
        <slot name="brand"/>
      </h3>
      <p class="text-neutral/500 mt-2 text-left">
        <slot name="short_description"/>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectsItem'
}
</script>

<style scoped>
.project-card {
  transition: border-color .3s ease, box-shadow .3s ease, transform .3s ease;
}

.project-card:hover {
  border-color: #FFCE1F;
  transform: translateY(-6px);
  box-shadow: 0 22px 40px rgba(4, 23, 41, .16);
}

@media (prefers-reduced-motion: reduce) {
  .project-card {
    transition: none;
  }

  .project-card:hover {
    transform: none;
  }
}
</style>
